export const FETCH_BALANCE_LOADING = 'FETCH_BALANCE_LOADING';
export const FETCH_BALANCE_SUCCESS = 'FETCH_BALANCE_SUCCESS';
export const FETCH_BALANCE_ERROR = 'FETCH_BALANCE_ERROR';

